import { useQuery } from '@tanstack/react-query';
import { MdError } from 'react-icons/md';
import { toast } from 'react-toastify';
import ReactIcon from '../components/ReactIcon';
import calendarServices from '../services/calendar.service';

export const useCalendarPrices = ({
    productId,
    rangeStart,
    rangeEnd,
}: {
    productId?: string;
    rangeStart?: Date;
    rangeEnd?: Date;
} = {}) => {
    const { isPending, data } = useQuery({
        queryKey: [
            `CalendarPrice/${productId}/${rangeStart?.toISOString()}/${rangeEnd?.toISOString()}`,
        ],
        queryFn: async () => {
            if (!productId || !rangeStart || !rangeEnd) {
                throw new Error('Missing required parameters');
            }
            const response = await calendarServices.fetchPrices(
                productId,
                rangeStart,
                rangeEnd
            );
            return response;
        },
        throwOnError: () => {
            // if (!token) return false;
            toast.error(() => 'Erro ao carregar preços no calendário', {
                toastId: 5,
                style: {
                    fontSize: '1rem',
                    fontWeight: '400',
                },
                position: 'top-right',
                autoClose: 5000,
                icon: (
                    <ReactIcon
                        Icon={MdError}
                        size={'1.5rem'}
                        fill="#e40505"
                        color="white"
                    />
                ),
            });
            return false;
        },
        enabled: !!(productId && rangeStart && rangeEnd),
    });

    return {
        isPending,
        data,
    };
};
